module.exports = __webpack_public_path__ + "img/lancang-dam.dd6e1462.jpg";